// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".forum_category_module-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 15px; }\n  .forum_category_module-layout .form-create-category {\n    display: flex;\n    align-items: center;\n    gap: 10px; }\n  .forum_category_module-layout .category-forum-item {\n    padding: 10px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    box-shadow: var(--shadow); }\n", ""]);
// Exports
module.exports = exports;
